import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { bookingActions } from "redux/slices/booking";
import {
  formatTimeForDisplay,
  readStoredTimeFormat,
  storeTimeFormat,
  type HourMode,
} from "utils/timeFormat.util";

let restoredFromStorage = false;

export default function useBookingTimeFormat() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const format = useAppSelector((state) => state.booking.timeFormat ?? "24");

  useEffect(() => {
    if (restoredFromStorage) return;
    restoredFromStorage = true;
    const stored = readStoredTimeFormat();
    if (stored && stored !== format) {
      dispatch(bookingActions.setTimeFormat(stored));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveFormat = useCallback(
    (mode: HourMode) => {
      storeTimeFormat(mode);
      dispatch(bookingActions.setTimeFormat(mode));
    },
    [dispatch]
  );

  const display = useCallback(
    (value?: string) =>
      formatTimeForDisplay(value, format, {
        am: t("am", "AM"),
        pm: t("pm", "PM"),
      }),
    [format, t]
  );

  return { format, saveFormat, display };
}
